import { axiosClient } from "@/shared/api/axios-client";
import type { MiSolicitud, SolicitudDetalle } from "@/lib/types";

/**
 * Conteos del strip de stats · calculados en el server sobre el set filtrado
 * completo (con filtros de columna, SIN el quickFilter): los cards conservan
 * sus conteos aunque uno esté activo. `total` es el pre-quickFilter que
 * muestra el card "Total" (el `total` de la página sí refleja el quickFilter).
 */
export interface MisSolicitudesStats {
  total: number;
  enCaptura: number;
  requierenAccion: number;
  enAutorizacion: number;
}

/** Página del listado · espejo de MisSolicitudesPageDto del backend. */
export interface MisSolicitudesPage {
  items: MiSolicitud[];
  total: number;
  page: number;
  pageSize: number;
  stats: MisSolicitudesStats;
}

/**
 * Subset de `solicitudes-api.ts` con la firma puramente funcional que
 * pide la nueva arquitectura. Conforme migramos features, vamos sumando
 * métodos acá y eliminando los del archivo viejo.
 */
export const solicitudesApi = {
  obtener: (id: string) =>
    axiosClient
      .get<SolicitudDetalle>(`/api/solicitudes/${id}`)
      .then((r) => r.data),

  listarMias: (params: Record<string, string | number | boolean> = {}) =>
    axiosClient
      .get<MisSolicitudesPage>("/api/solicitudes/mias", { params })
      .then((r) => r.data),

  cancelar: (id: string, motivos: string[]) =>
    axiosClient
      .post<SolicitudDetalle>(`/api/solicitudes/${id}/cancelar`, { motivos })
      .then((r) => r.data),
};
